import { getCadenceAnalyticsSummarize } from "../types/cadence_analytics_summarize_types";

const initState = {
  data: [],
  loading: false,
  error: null,
};

export default function cadenceAnalyticsSummarizeReducer(state = initState, action = {}) {
  switch (action.type) {
    case getCadenceAnalyticsSummarize.GET_CADENCE_ANALYTICS_SUMMARIZE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case getCadenceAnalyticsSummarize.GET_CADENCE_ANALYTICS_SUMMARIZE_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: null,
      };
    case getCadenceAnalyticsSummarize.GET_CADENCE_ANALYTICS_SUMMARIZE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
